import { withStyles } from '@material-ui/core';
import SpeedDial from './SpeedDial';
import styles from './SpeedDial.styles';

export default withStyles(styles)(SpeedDial);
